export const advantageData = [
    {
        id: 1,
        name: 'Тариф Mobile — бесплатно',
        desc: 'Если у вас есть телевидение от Дом.ру, то автоматически вам подключается бесплатный тариф ' +
            '«Смотри везде Mobile». Он не отключится, пока вы остаетесь клиентом. С ним можно смотреть ТВ ' +
            'на мобильных устройствах.',
        imgSrc: '/static/images/domru-tv/watch_icon1.png',
    },
    {
        id: 2,
        name: 'Все каналы и фильмы — на всех экранах ',
        desc: 'Все, что вы подключите на одном устройстве, автоматически появится на других. Например, купите фильм ' +
            'или пакет каналов на телевизоре, а смотрите его на ноутбуке или смартфоне.',
        imgSrc: '/static/images/domru-tv/watch_icon2.png',
    },
    {
        id: 3,
        name: 'Смотрите ТВ там, где удобно',
        desc: 'Смотрите фильмы и передачи на смартфоне или планшете или ноутбуке. Всё что нужно — авторизоваться в ' +
            'приложении или на сайте «Дом.ру Movix». Это бесплатно.',
        imgSrc: '/static/images/domru-tv/watch_icon3.png',
    },
];
